import gql from 'graphql-tag';

export const LOOKUP_USER_REWARD = gql`
  query GetUserRewardInfo($userId: Int!) {
    lookupUserReward(userId: $userId) {
      totalRewardValue
      nextRewardDate
      nextRewardAmount
      result
      message
    }
  }
`;

export const userRewardSuccess = {
  lookupUserReward: {
    totalRewardValue: 25,
    nextRewardDate: '12012023',
    nextRewardAmount: 25,
    result: null,
    message: null,
  },
};

export const userRewardError = {
  lookupUserReward: {
    result: 'error',
    message: 'Error message',
    totalRewardValue: null,
    nextRewardDate: null,
    nextRewardAmount: null,
  },
};

export const GET_REWARDS_REDIRECT_TOKEN = gql`
  query GetRewardsRedirectionToken($userId: Int!) {
    getTokenUserReward(userId: $userId) {
      result
      token
    }
  }
`;

export const getRedirectUrlTokenSuccess = {
  getTokenUserReward: {
    result: 'success',
    token: 'token',
  },
};

export const GET_USER_REWARD_STATUS = gql`
  query GetUserRewardStatus($userId: Int!) {
    getUserReward(userId: $userId) {
      id
      status
    }
    user(id: $userId) {
      zipCode {
        state {
          name
        }
      }
    }
  }
`;

export const getUserRewardStatusActive = {
  getUserReward: {
    id: 10,
    status: 'active',
  },
};

export const getUserRewardStatusPending = {
  getUserReward: {
    id: 10,
    status: 'pending',
  },
};

export const getUserRewardStatusError = {
  getUserReward: {
    id: 10,
    status: 'cancelled',
  },
};
